module.exports = __webpack_public_path__ + "static/media/10_l_sit_12.29_82.69.20f6f58a.png";